import * as Desktop from './Desktop';
import * as Mobile from './Mobile';

export { Desktop, Mobile };
